import script from "./DocsTypeSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsTypeSwitch.vue?vue&type=script&setup=true&lang=js"

import "./DocsTypeSwitch.vue?vue&type=style&index=0&id=a8740ed2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8740ed2"]])

export default __exports__